// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Navbar_wrapper__2xXU_","logo_block":"Navbar_logo_block__MWwG4","logo":"Navbar_logo__1H3m4","button_block":"Navbar_button_block__VKt1_","version":"Navbar_version__-dzS4"};